





import {Component, Vue} from 'vue-property-decorator';
import PagedTable from '@/components/Views/Dashboard/PagedTable.vue';

@Component({
    components: {
        PagedTable,
    },
})
export default class DashboardCategories extends Vue {
    private dialog = false;
    private headers = [];
}
